import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as AnimationModules from 'src/modules/animation/stores'
import createMediator from './mediator-plugin'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ...modules,
    ...AnimationModules,
  },
  plugins: [
    createPersistedState({
      key: 'admin-ccpm',
      paths: ['me', 'animation'],
      reducer (val) {
        return val?.me?.tokens ? val : {}
      },
    }),
    createMediator({
      listeners: [
        { on: 'me/LOGOUT', dispatch: 'animation/resetState' },
      ],
    }),
  ],
})
